var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
const sumAllDailyDpm = (total, { hourlyAverageUTS = 0 }) => total + hourlyAverageUTS;
const accountDailyUsageAvg = ({ dailyUsage }) => !dailyUsage.length ? 0 : dailyUsage.reduce(sumAllDailyDpm, 0) / dailyUsage.length;
export class MetricsAccountBudgetModel {
    dpm;
    hasMetrics;
    maxMetricsSubAccounts;
    metricsAccounts;
    budgetUTS;
    get hasActiveMetricsAccounts() {
        return this.metricsAccounts?.length > 0;
    }
    get uniqueMetrics() {
        return this.budgetUTS;
    }
    get totalUsage() {
        return this.metricsAccounts.reduce((usage, account) => usage + accountDailyUsageAvg(account), 0);
    }
}
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MetricsAccountBudgetModel.prototype, "hasActiveMetricsAccounts", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MetricsAccountBudgetModel.prototype, "uniqueMetrics", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MetricsAccountBudgetModel.prototype, "totalUsage", null);
//# sourceMappingURL=metrics-account-budget.js.map